export const CL_ACCESS_TOKEN = process.env.CL_ACCESS_TOKEN;
export const CL_STANDARD_URL = process.env.CL_STANDARD_URL;
export const CL_BASIC_URL = process.env.CL_BASIC_URL
export const CL_SERVICES_TOKEN = process.env.CL_SERVICES_TOKEN
export const CL_SERVICES_BASE_URL = process.env.CL_SERVICES_BASE_URL